import { object, func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import interceptUpdater from 'coact-utils/interceptUpdater'

import HeadEditorView from './HeadEditor'


const HeadEditor = scope(
  consumeProps({
    value: object,
    onChange: func.isRequired,
  }),

  interceptUpdater('onChange', () => value => {
    const { stafferRef, companyRef, supplierRef } = value

    return {
      ...value,
      stafferDoc: stafferRef,
      companyDoc: companyRef,
      supplierDoc: supplierRef,
    }
  }),

  exposeProps([
    'value',
    'onChange',
  ]),
)(HeadEditorView)

HeadEditor.displayName = 'HeadEditor'

export default HeadEditor



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderEditor/HeadEditor/index.js